import { useEffect, useRef, useState } from 'react';
import { voiceApi } from './voiceApi';
import { isDialableNumber } from './callFormat';

const EMPTY = { number: null, matches: [], loading: false };

/**
 * Who has the typed number on file? Debounced GET /voice/students/by-phone, keyed on the digits so
 * re-formatting the same number does not query again. Runs only once the number is complete and
 * while `enabled`; a failed lookup just shows nothing (the server auto-attaches at call time anyway).
 * Returns { number: E.164 the server resolved | null, matches: [{ ...student, contact_label }], loading }.
 */
export const usePhoneLookup = (raw, enabled = true) => {
    const [state, setState] = useState(EMPTY);
    const seq = useRef(0);
    const key = enabled && isDialableNumber(raw) ? String(raw).trim().replace(/[^\d+]/g, '') : '';

    useEffect(() => {
        const mySeq = ++seq.current;
        if (!key) { setState(EMPTY); return undefined; }
        setState({ number: null, matches: [], loading: true }); // never show the previous number's student
        const id = setTimeout(async () => {
            try {
                const data = await voiceApi.lookupContacts(key);
                if (mySeq === seq.current) setState({ number: data.number || null, matches: data.matches || [], loading: false });
            } catch {
                if (mySeq === seq.current) setState(EMPTY);
            }
        }, 300);
        return () => clearTimeout(id);
    }, [key]);

    return state;
};

export default usePhoneLookup;
